import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroBanner from "./components/HeroBanner";
import QuickEntry from "./components/QuickEntry";
import CategorySection from "./components/CategorySection";
import HotProducts from "./components/HotProducts";
import AdvantageSection from "./components/AdvantageSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-16">
        <HeroBanner />
        <QuickEntry />
        <CategorySection />
        <HotProducts />
        <AdvantageSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
